import React from 'react';
import { Route, Redirect } from 'react-router-dom';



const GuestRoute = ({ component: Component, isGuest, ...rest }) => (
  <Route {...rest} render={props => (
    isGuest ?
      (<Component {...props}/> ) :
      (<Redirect to={{ pathname: '/', state: { from: props.location }}}/>)
  )}/>
)


export default GuestRoute;



// WEBPACK FOOTER //
// ./src/components/Auth/GuestRoute.js